/* eslint-disable camelcase */
export var style = {
    demo: {
        primary: '#1A1F39',
        primaryDark: '#051d3b',
        primaryLight: '#f9c532',
        accent: '#f9c532',
    },
    slas: {
        primary: '#6e9bd2',
        primaryDark: '#55769e',
        primaryLight: '#FFFFFF',
        accent: '#FFFFFF',
    },
    test: {
        primary: '#2196F3',
        primaryDark: '#1976D2',
        primaryLight: '#E3F2FD',
        accent: '#FFFFFF',
    },
    ambulans_blekinge: {
        primary: '#215287',
        primaryDark: '#1d4877',
        primaryLight: '#E8EAF6',
        accent: '#ffcc00',
    },
    ambulans_jonkoping: {
        primary: '#b1063a',
        primaryDark: '#b1063a',
        primaryLight: '#DF9BB0',
        accent: '#FFFFFF',
    },
    ambulans_orebro: {
        primary: '#0067B2',
        primaryDark: '#004F9E',
        primaryLight: '#B2DEF2',
        accent: '#5AB031',
    },
    ambulans_vastmanland: {
        primary: '#1f49a1',
        primaryDark: '#103a90',
        primaryLight: '#f8dd00',
        accent: '#f8dd00',
    },
    ambulans_sahlgrenska: {
        primary: '#006298',
        primaryDark: '#006298',
        primaryLight: '#e5eff4',
        accent: '#ffffff',
    },
    ambulans_halland: {
        primary: '#006858',
        primaryDark: '#006858',
        primaryLight: '#E5F2E5',
        accent: '#ffffff',
    },
    ambulans_skane: {
        primary: '#1F8565',
        primaryDark: '#1F8565',
        primaryLight: '#C8E4DB',
        accent: '#ffffff',
    },
    ambulans_ssih_sormland: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    lakemedel_gavleborg: {
        primary: '#50B848',
        primaryDark: '#388E3C',
        primaryLight: '#E8F5E9',
        accent: '#4058FF',
    },
    polis_appen: {
        primary: '#163c6b',
        primaryDark: '#051d3b',
        primaryLight: '#f9c532',
        accent: '#f9c532',
    },
    strama_gavleborg: {
        primary: '#FFC107',
        primaryDark: '#FFA000',
        primaryLight: '#FFFDE7',
        accent: '#EB1F21',
    },
    strama_jonkoping: {
        primary: '#F44336',
        primaryDark: '#D32F2F',
        primaryLight: '#FFEBEE',
        accent: '#303030',
    },
    strama_nationell: {
        primary: '#5c92c4',
        primaryDark: '#1E88E5',
        primaryLight: '#E3F2FD',
        accent: '#FFD82B',
    },
    ambulans_vasternorrland: {
        primary: '#009fe3',
        primaryDark: '#1E88E5',
        primaryLight: '#E3F2FD',
        accent: '#ffcc00',
    },
    ambulans_norrbotten: {
        primary: '#C73238',
        primaryDark: '#B2292E',
        primaryLight: '#E3F2FD',
        accent: '#E3F2FD',
    },
    strama_orebro: {
        primary: '#9FC53A',
        primaryDark: '#008B39',
        primaryLight: '#DCEBBD',
        accent: '#004F9E',
    },
    ambulans_sormland: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    strama_varmland: {
        primary: '#003c68',
        primaryDark: '#003c68',
        primaryLight: '#66b4ff',
        accent: '#f9b000',
    },
    mps_appen: {
        primary: '#414f5a',
        primaryDark: '#414f5a',
        primaryLight: '#d8e4f0',
        accent: '#eee548',
    },
    raddningstjansten_syd: {
        primary: '#103250',
        primaryDark: '#103250',
        primaryLight: '#fffcf0',
        accent: '#f1b600',
    },
    falck_amb_stockholm: {
        primary: '#FF1E2D',
        primaryDark: '#66182A',
        primaryLight: '#ffff',
        accent: '#ffff',
    },
    softwerk: {
        primary: '#B72C25',
        primaryDark: '#080201',
        primaryLight: '#ffff',
        accent: '#ffff',
    },
    vc_bagis: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    ambulans_kronoberg: {
        primary: '#006633',
        primaryDark: '#003a0b',
        primaryLight: '#ffff',
        accent: '#E9EF4B',
    },
    ambulans_ostergotland: {
        primary: '#0066B3',
        primaryDark: '#0066B3',
        primaryLight: '#a9d7ff',
        accent: '#fed765',
    },
    ambulans_vasterbotten: {
        primary: '#0050A0',
        primaryDark: '#0050A0',
        primaryLight: '#DCE7F6',
        accent: '#ffffff',
    },
    falu_kommun: {
        primary: '#a63822',
        primaryDark: '#571204',
        primaryLight: '#f3e1dd',
        accent: '#ffffff',
    },
    saters_kommun: {
        primary: '#950024',
        primaryDark: '#950024',
        primaryLight: '#d9c7cc',
        accent: '#ffffff',
    },
    primarvard_sormland: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    internmedicin_helsingborg: {
        primary: '#ED0025',
        primaryDark: '#ED0025',
        primaryLight: '#ffd9df',
        accent: '#FFFFFF',
    },
    raddsamy: {
        primary: '#104C90',
        primaryDark: '#104C90',
        primaryLight: '#e7edf3',
        accent: '#FFFFFF',
    },
    test_project: {
        primary: '#104C90',
        primaryDark: '#104C90',
        primaryLight: '#e7edf3',
        accent: '#FFFFFF',
    },
    akutkliniken_nykoping: {
        primary: '#9D1458',
        primaryDark: '#9D1458',
        primaryLight: '#FCE4E9',
        accent: '#FFFFFF',
    },
    samariten_gotland: {
        primary: '#DE0D13',
        primaryDark: '#87070b',
        primaryLight: '#ffffff',
        accent: '#ffffff',
    },
    showroom: {
        primary: '#1A1F39',
        primaryDark: '#051d3b',
        primaryLight: '#eaeaea',
        accent: '#FFF',
    },
    smartyta: {
        primary: '#007EBF',
        primaryDark: '#007EBF',
        primaryLight: '#cfebfa',
        accent: '#FFF',
    },
    ekg_appen: {
        primary: '#006600',
        primaryDark: '#006600',
        primaryLight: '#ffffff',
        accent: '#64B552',
    },
    urologi_helsingborg: {
        primary: '#09A28F',
        primaryDark: '#09A28F',
        primaryLight: '#D2D70A',
        accent: '#ffffff',
    },
    hjartkliniken: {
        primary: '#387d71',
        primaryDark: ' #387d71',
        primaryLight: '#d8d1ca',
        accent: '#a89c94',
    },
};
//# sourceMappingURL=style.js.map